import React from "react"
import { SolucionesBar } from "../SolucionesBar"
import { StaticImage } from "gatsby-plugin-image"
import "./landing.scss"

export const LandingSection = ({ classTitle }) => {
  return (
    <>
      <section id="Home" className={`${classTitle}-landing-section`}>
        <StaticImage
          src="../../../images/home/Header.jpg"
          alt={`${classTitle}-landing-image`}
          className={`${classTitle}-landing-image`}
        />
        <div
          className={`${classTitle}-landing-title`}
          data-sal="slide-right"
          data-sal-delay="300"
          data-sal-easing="ease"
        >
          <h1 className="mb-0 title-blue">La nueva era de</h1>
          <h1 className="mb-0 title-orange">la integración visual</h1>
          <h3 className="mb-0 subtitle">Cuente con nuestra experiencia</h3>
        </div>
        <SolucionesBar />
      </section>
    </>
  )
}
